exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-img[data-v-7c5efb2c] {\n    transform: rotate3d(0, 0, 1, 0deg);\n    background-size: 100% 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/vue-loader/lib/loaders/stylePostLoader.js!./~/vue-loader/lib?{}!./src/render/index.vue?vue&type=style&index=0&id=7c5efb2c&scoped=true&lang=css&
// module id = 16
// module chunks = 1